import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('AdminUser')
export class AdminUser {

    @JsonProperty('user_id', Number)
    userId: number = 0;

    @JsonProperty('email', String)
    email: string = '';
}